import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import greenIconUrl from "../../../../assets/markerIcons/marker-icon-2x-green.png";
import markerShadowUrl from "../../../../assets/markerIcons/marker-shadow.png";

const greenIcon = new L.Icon({
    iconUrl: greenIconUrl,
    shadowUrl: markerShadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

const getLastLoginEvent = (events) => {
    let lastEvent = null;
    let lastTime = -Infinity;
    events.forEach((event) => {
        if (event?.step !== "login") return;
        const time = Date.parse(event.event_date);
        const eventTime = isNaN(time) ? -Infinity : time;
        if (eventTime >= lastTime) {
            lastEvent = event;
            lastTime = eventTime;
        }
    });
    return lastEvent;
};

export const getLoginPosition = (signer) => {
    const events = signer?.signer_signature_step_events;
    if (!Array.isArray(events)) return null;
    const loginEvent = getLastLoginEvent(events);
    const coordinates = loginEvent?.event_data?.gps_data?.coordinates;
    if (!Array.isArray(coordinates) || coordinates.length < 2) return null;
    const [lng, lat] = coordinates;
    if (typeof lng !== "number" || typeof lat !== "number" || !isFinite(lng) || !isFinite(lat)) return null;
    return [lat, lng];
};

function InvalidateSizeOnMount() {
    const map = useMap();
    useEffect(() => {
        const timer = setTimeout(() => map.invalidateSize(), 400);
        return () => clearTimeout(timer);
    }, [map]);
    return null;
}

function SignerLoginMap({ signer }) {
    const position = getLoginPosition(signer);

    if (!position) return null;

    const [latitude, longitude] = position;

    return (
        <div>
            <span style={{ fontSize: "16px", color: "#0b1f82" }}>
                <strong>Localização do login</strong>
            </span>
            <p style={{ fontSize: "14px", marginTop: "5px", marginBottom: "10px" }}>
                Localização do GPS do assinante no momento do login:
            </p>
            <MapContainer
                center={position}
                zoom={14}
                style={{ height: "260px", width: "100%" }}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker position={position} icon={greenIcon}>
                    <Popup>Coordenadas do GPS do login</Popup>
                </Marker>
                <InvalidateSizeOnMount />
            </MapContainer>
            <p style={{ fontSize: "14px", marginTop: "10px" }}>
                <span><strong>Latitude:</strong></span>
                <span style={{ marginLeft: "5px" }}>{latitude}</span>
                <span style={{ marginLeft: "20px" }}><strong>Longitude:</strong></span>
                <span style={{ marginLeft: "5px" }}>{longitude}</span>
            </p>
        </div>
    );
}

export default SignerLoginMap;
